// src/components/CardDetailModal.jsx
import React from 'react';
import TarotCard from './TarotCard';

const CardDetailModal = ({ card, onClose }) => {
  if (!card) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-content--card" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-btn" aria-label="Cerrar">✕</button>
        <div className="card-detail-layout">
          <div className="card-detail-visual">
            <TarotCard card={card} isFlipped={true} />
          </div>
          <div className="card-detail-info">
            <h3 className="card-detail-name font-cinzel">{card.name}</h3>
            {card.suit && (
              <p className="card-detail-suit">
                {card.suit === 'Major Arcana' ? 'Arcano Mayor' : `Palo de ${card.suit}`}
              </p>
            )}
            <div className="card-detail-meaning">
              <div className="meaning-block">
                <h4 className="meaning-label">☀️ Derecha</h4>
                <p className="meaning-text">{card.meaning_up}</p>
              </div>
              <div className="meaning-block">
                <h4 className="meaning-label">🌙 Invertida</h4>
                <p className="meaning-text">{card.meaning_rev}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardDetailModal;
